import { render, staticRenderFns } from "./ProductReport.vue?vue&type=template&id=955945e4&scoped=true&"
import script from "./ProductReport.vue?vue&type=script&lang=js&"
export * from "./ProductReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductReport.vue?vue&type=style&index=0&id=955945e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955945e4",
  null
  
)

export default component.exports